import { Application } from "@hotwired/stimulus"

export function stimulusApplication() {
  if (!window.Stimulus) {
    window.Stimulus = Application.start()
  }

  return window.Stimulus
}
